import React, { useState, useEffect, useRef } from 'react';
import { 
  FiMenu, 
  FiX, 
  FiPhone, 
  FiMail, 
  FiChevronDown,
  FiUser,
  FiLogIn,
  FiCalendar,
  FiHeadphones,
  FiHome,
  FiInfo,
  FiTruck,
  FiPhoneCall,
  FiStar,
  FiArrowRight
} from 'react-icons/fi';
import { 
  FaWhatsapp,
  FaFacebookF,
  FaTwitter,
  FaInstagram,
  FaLinkedinIn
} from 'react-icons/fa';
import { MdOutlineLocalTaxi } from 'react-icons/md';
import { IoLocationOutline } from 'react-icons/io5';
import Logo from "../assets/WhatsApp_Image_2026-02-24_at_10.33.50_AM-removebg-preview.png";
import { useNavigate } from 'react-router-dom';

const Header = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const [activeDropdown, setActiveDropdown] = useState(null);
  const [isMobile, setIsMobile] = useState(false);
  const [isInitialized, setIsInitialized] = useState(false);
  const navigate = useNavigate();
  const menuRef = useRef(null);
  const menuButtonRef = useRef(null);

  // Colors
  const colors = {
    primary: '#28aa96', 
    logo:'#28aa972e'  , // Teal
    accent: '#e7814c',     // Orange/Coral
    dark: '#1e2b3a',
    light: '#ffffff',
    gray: '#f8fafc',
    text: '#334155'
  };

  // Initialize mobile detection immediately
  useEffect(() => {
    const checkMobile = () => {
      const mobile = window.innerWidth <= 768;
      setIsMobile(mobile);
      setIsInitialized(true);
    };
    
    checkMobile();
    window.addEventListener('resize', checkMobile);
    
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // Handle click outside to close menu
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (isOpen && menuRef.current && !menuRef.current.contains(event.target) && 
          menuButtonRef.current && !menuButtonRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    document.addEventListener('touchstart', handleClickOutside);
    
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
      document.removeEventListener('touchstart', handleClickOutside);
    };
  }, [isOpen]);

  // Handle body scroll lock
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
    
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isOpen]);

  // Handle escape key press
  useEffect(() => {
    const handleEscKey = (event) => {
      if (event.key === 'Escape' && isOpen) {
        setIsOpen(false);
      }
    };

    document.addEventListener('keydown', handleEscKey);
    
    return () => {
      document.removeEventListener('keydown', handleEscKey);
    };
  }, [isOpen]);

  const navItems = [
    { title: 'Home', href: '/', icon: <FiHome size={18} /> },
    { title: 'About Us', href: '/about', icon: <FiInfo size={18} /> },
    { 
      title: 'Services', 
      href: '#', // Change to # to prevent navigation
      icon: <FiTruck size={18} />,
      dropdown: [
        { 
          title: 'Airport Transfer', 
          href: 'services/airport-transfer', 
          icon: <MdOutlineLocalTaxi size={16} />,
          serviceType: 'airport' // Add service type
        },
        { 
          title: 'Outstation Trips', 
          href: 'services/outstation-trips', 
          icon: <FiTruck size={16} />,
          serviceType: 'outstation' // Add service type
        },
        { 
          title: 'Local Packages', 
          href: 'services/local', 
          icon: <FiCalendar size={16} />,
          serviceType: 'local' // Add service type
        },
       
      ]
    },
    { title: 'Attach Your Cab', href: '/attachyourcab', icon: <MdOutlineLocalTaxi size={18} /> },
    { title: 'Contact', href: '/contact', icon: <FiPhoneCall size={18} /> },
  ];

  const handleDropdownHover = (index) => {
    if (!isMobile) {
      setActiveDropdown(index);
    }
  };

  const handleNavigation = (path, serviceType = null) => {
    if (serviceType) {
      // If it's a booking with service type, pass the state
      navigate(path, { state: { serviceType } });
    } else {
      navigate(path);
    }
    setIsOpen(false);
    setActiveDropdown(null);
  };

  const handleMobileLinkClick = (e, href, hasDropdown = false, serviceType = null) => {
    if (!hasDropdown) {
      e.preventDefault();
      handleNavigation(href, serviceType);
    }
  };

  // Don't render anything until we know the device type
  if (!isInitialized) {
    return null;
  }

  return (
    <>
      {/* Top Bar - Hidden on Mobile */}
      <div style={{ 
        background: colors.primary,
        color: colors.light,
        padding: '8px 0',
        display: isMobile ? 'none' : 'block'
      }}>
        <div style={{
          maxWidth: 1200,
          margin: '0 auto',
          padding: '0 20px',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          fontSize: 13
        }}>
          <div style={{ display: 'flex', gap: 30 }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
              <FiPhone size={14} />
              <span>+91 91504 10309</span>
            </div>
            <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
              <FiMail size={14} />
              <span>safetrackcabservice@gmail.com</span>
            </div>
            <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
              <IoLocationOutline size={14} />
              <span>Chennai</span>
            </div>
          </div>
          <div style={{ display: 'flex', gap: 15 }}>
            <a href="#" style={{ color: colors.light, transition: 'opacity 0.2s', ':hover': { opacity: 0.8 } }}>
              <FaFacebookF size={14} />
            </a>
            <a href="#" style={{ color: colors.light, transition: 'opacity 0.2s', ':hover': { opacity: 0.8 } }}>
              <FaTwitter size={14} />
            </a>
            <a href="#" style={{ color: colors.light, transition: 'opacity 0.2s', ':hover': { opacity: 0.8 } }}>
              <FaInstagram size={14} />
            </a>
            <a href="#" style={{ color: colors.light, transition: 'opacity 0.2s', ':hover': { opacity: 0.8 } }}>
              <FaLinkedinIn size={14} />
            </a>
          </div>
        </div>
      </div>

      {/* Main Header */}
      <header style={{
        position: 'sticky',
        top: 0,
        zIndex: 1000,
        background: colors.light,
        boxShadow: scrolled ? '0 4px 20px rgba(0,0,0,0.1)' : 'none',
        transition: 'all 0.3s ease',
        borderBottom: scrolled ? 'none' : `1px solid ${colors.gray}`
      }}>
        <div style={{
          maxWidth: 1200,
          margin: '0 auto',
          padding: isMobile ? '12px 16px' : '8px 20px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between'
        }}>
          {/* Logo */}
          <a 
            href="/" 
            onClick={(e) => {
              e.preventDefault();
              handleNavigation('/');
            }}
            style={{ display: 'flex', alignItems: 'center', gap: 3, textDecoration: 'none', cursor: 'pointer' }}
          >
            <div className="logo" style={{ width: isMobile ? 50 : 70, height: isMobile ? 40 : 55,background: colors.logo,borderRadius: 8, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              <img src={Logo} alt="Safe Track Cabs Logo" style={{ width:"100%", maxWidth: isMobile ? 50 : 70, height: "auto" }} />
            </div>
            <div>
              <h1 style={{ 
                fontSize: isMobile ? 18 : 22, 
                fontWeight: 700, 
                margin: 0,
                lineHeight: 1.2
              }}>
                <span style={{ color: colors.primary }}>Safe Track </span>
                <span style={{ color: colors.dark }}>Cab Service</span>
              </h1>
              {!isMobile && (
                <p style={{ 
                  fontSize: 10, 
                  color: colors.accent,
                  margin: 0,
                  letterSpacing: 1,
                  fontWeight: 500
                }}>
                  SAFE • RELIABLE • TRUSTED
                </p>
              )}
            </div>
          </a>

          {/* Desktop Navigation */}
          {!isMobile && (
            <nav style={{ display: 'flex', alignItems: 'center', gap: 30 }}>
              {navItems.map((item, index) => (
                <div
                  key={index}
                  style={{ position: 'relative' }}
                  onMouseEnter={() => handleDropdownHover(index)}
                  onMouseLeave={() => setActiveDropdown(null)}
                >
                  {item.dropdown ? (
                    <span
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: 4,
                        color: colors.text,
                        fontSize: 15,
                        fontWeight: 500,
                        padding: '8px 0',
                        borderBottom: activeDropdown === index ? `2px solid ${colors.accent}` : '2px solid transparent',
                        transition: 'all 0.2s',
                        cursor: 'default'
                      }}
                    >
                      {item.icon}
                      {item.title}
                      <FiChevronDown size={16} style={{ marginLeft: 2 }} />
                    </span>
                  ) : (
                    <a
                      href={item.href}
                      onClick={(e) => {
                        e.preventDefault();
                        handleNavigation(item.href);
                      }}
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: 4,
                        color: colors.text,
                        textDecoration: 'none',
                        fontSize: 15,
                        fontWeight: 500,
                        padding: '8px 0',
                        borderBottom: activeDropdown === index ? `2px solid ${colors.accent}` : '2px solid transparent',
                        transition: 'all 0.2s',
                        cursor: 'pointer'
                      }}
                    >
                      {item.icon}
                      {item.title}
                    </a>
                  )}

                  {/* Dropdown Menu */}
                  {item.dropdown && activeDropdown === index && (
                    <div style={{
                      position: 'absolute',
                      top: '100%',
                      left: 0,
                      background: colors.light,
                      borderRadius: 8,
                      boxShadow: '0 10px 30px rgba(0,0,0,0.15)',
                      minWidth: 220,
                      padding: '8px 0',
                      zIndex: 1000,
                      animation: 'fadeIn 0.2s ease'
                    }}>
                      {item.dropdown.map((dropItem, dropIndex) => (
                        <a
                          key={dropIndex}
                          href={dropItem.href}
                          onClick={(e) => {
                            e.preventDefault();
                            handleNavigation(dropItem.href, dropItem.serviceType);
                          }}
                          style={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: 10,
                            padding: '10px 16px',
                            color: colors.text,
                            textDecoration: 'none',
                            fontSize: 14,
                            transition: 'all 0.2s',
                            cursor: 'pointer',
                            ':hover': {
                              background: `${colors.primary}10`,
                              color: colors.primary
                            }
                          }}
                        >
                          {dropItem.icon}
                          {dropItem.title}
                        </a>
                      ))}
                    </div>
                  )}
                </div>
              ))}

              {/* Action Buttons */}
              <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
                <a
                  href="tel:+919150410309"
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: 8,
                    padding: '8px 16px',
                    background: colors.accent,
                    color: colors.light,
                    textDecoration: 'none',
                    borderRadius: 6,
                    fontSize: 14,
                    fontWeight: 600,
                    transition: 'all 0.2s',
                    ':hover': {
                      background: '#d66d3a',
                      transform: 'translateY(-2px)'
                    }
                  }}
                >
                  <FiPhone size={16} />
                  Call Now
                </a>
                <a
                  href="https://wa.me/919150410309"
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    width: 40,
                    height: 40,
                    background: '#25D366',
                    color: colors.light,
                    borderRadius: '50%',
                    transition: 'all 0.2s',
                    ':hover': {
                      transform: 'scale(1.1)'
                    }
                  }}
                >
                  <FaWhatsapp size={20} />
                </a>
              </div>
            </nav>
          )}

          {/* Mobile Menu Button */}
          {isMobile && (
            <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
              <a
                href="tel:+919150410309"
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  width: 40,
                  height: 40,
                  background: colors.accent,
                  color: colors.light,
                  borderRadius: '50%'
                }}
              >
                <FiPhone size={18} />
              </a>
              <button
                ref={menuButtonRef}
                onClick={() => setIsOpen(!isOpen)}
                style={{
                  background: 'none',
                  border: 'none',
                  cursor: 'pointer',
                  padding: 8,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center'
                }}
              >
                {isOpen ? (
                  <FiX size={28} color={colors.dark} />
                ) : (
                  <FiMenu size={28} color={colors.dark} />
                )}
              </button>
            </div>
          )}
        </div>
      </header>

      {/* Mobile Menu Overlay */}
      {isMobile && isOpen && (
        <div 
          ref={menuRef}
          style={{
            position: 'fixed',
            top: 72,
            left: 0,
            right: 0,
            bottom: 0,
            background: colors.light,
            zIndex: 999,
            overflowY: 'auto',
            animation: 'slideIn 0.3s ease'
          }}
        >
          <nav style={{ padding: '20px 16px 30px' }}>
            {/* User Section */}
            <div style={{
              background: `linear-gradient(135deg, ${colors.primary}15 0%, ${colors.accent}10 100%)`,
              borderRadius: 12,
              padding: 16,
              marginBottom: 24
            }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 14 }}>
                <div style={{
                  width: 48,
                  height: 48,
                  borderRadius: '50%',
                  background: colors.primary,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center'
                }}>
                  <FiUser size={24} color={colors.light} />
                </div>
                <div>
                  <h3 style={{ fontSize: 16, fontWeight: 600, color: colors.dark, margin: 0 }}>
                    Guest User
                  </h3>
                  <p style={{ fontSize: 13, color: colors.text, margin: '4px 0 0' }}>
                    Sign in for faster booking
                  </p>
                </div>
              </div>
              <div style={{ display: 'flex', gap: 8 }}>
                <button 
                  onClick={() => handleNavigation('/signin')}
                  style={{
                    flex: 1,
                    padding: '8px 0',
                    background: colors.primary,
                    border: 'none',
                    borderRadius: 6,
                    color: colors.light,
                    fontSize: 13,
                    fontWeight: 600,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    gap: 6,
                    cursor: 'pointer'
                  }}
                >
                  <FiLogIn size={14} /> Sign In
                </button>
                <button
                  onClick={() => handleNavigation('/signup')}
                  style={{
                    flex: 1,
                    padding: '8px 0',
                    background: 'transparent',
                    border: `1px solid ${colors.primary}`,
                    borderRadius: 6,
                    color: colors.primary,
                    fontSize: 13,
                    fontWeight: 600,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    gap: 6,
                    cursor: 'pointer'
                  }}
                >
                  <FiUser size={14} /> Register
                </button>
              </div>
            </div>

            {/* Navigation Links */}
            <div style={{ marginBottom: 24 }}>
              {navItems.map((item, index) => (
                <div key={index}>
                  <div
                    onClick={() => {
                      if (item.dropdown) {
                        setActiveDropdown(activeDropdown === index ? null : index);
                      } else {
                        handleNavigation(item.href);
                      }
                    }}
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'space-between',
                      padding: '14px 0',
                      color: colors.dark,
                      borderBottom: `1px solid ${colors.gray}`,
                      fontSize: 16,
                      fontWeight: 500,
                      cursor: 'pointer'
                    }}
                  >
                    <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
                      <span style={{ color: colors.primary }}>{item.icon}</span>
                      {item.title}
                    </div>
                    {item.dropdown && (
                      <FiChevronDown 
                        size={18} 
                        style={{ 
                          transform: activeDropdown === index ? 'rotate(180deg)' : 'none',
                          transition: 'transform 0.2s'
                        }} 
                      />
                    )}
                  </div>
                  
                  {/* Mobile Dropdown */}
                  {item.dropdown && activeDropdown === index && (
                    <div style={{ padding: '8px 0 8px 30px', background: colors.gray }}>
                      {item.dropdown.map((dropItem, dropIndex) => (
                        <div
                          key={dropIndex}
                          onClick={() => handleNavigation(dropItem.href, dropItem.serviceType)}
                          style={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: 10,
                            padding: '12px 0',
                            color: colors.text,
                            fontSize: 14,
                            borderBottom: dropIndex < item.dropdown.length - 1 ? `1px solid ${colors.light}` : 'none',
                            cursor: 'pointer'
                          }}
                        >
                          <span style={{ color: colors.primary }}>{dropItem.icon}</span>
                          {dropItem.title}
                          <FiArrowRight size={14} style={{ marginLeft: 'auto', color: colors.accent }} />
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              ))}
            </div>

            {/* Quick Actions */}
            <div style={{ marginBottom: 24 }}>
              <h4 style={{ fontSize: 14, color: colors.text, marginBottom: 12 }}>Quick Actions</h4>
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 8 }}>
                <div
                  onClick={() => handleNavigation('/booking', 'airport')}
                  style={{
                    padding: '12px',
                    background: colors.accent,
                    color: colors.light,
                    borderRadius: 8,
                    fontSize: 13,
                    fontWeight: 600,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    gap: 6,
                    cursor: 'pointer'
                  }}
                >
                  <FiCalendar size={16} />
                  Book Airport
                </div>
                <div
                  onClick={() => handleNavigation('/booking', 'outstation')}
                  style={{
                    padding: '12px',
                    background: colors.primary,
                    color: colors.light,
                    borderRadius: 8,
                    fontSize: 13,
                    fontWeight: 600,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    gap: 6,
                    cursor: 'pointer'
                  }}
                >
                  <FiHeadphones size={16} />
                  Book Outstation
                </div>
              </div>
            </div>

            {/* Contact Info */}
            <div style={{
              background: colors.gray,
              borderRadius: 12,
              padding: 16
            }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 12 }}>
                <FiPhone size={16} color={colors.accent} />
                <div>
                  <div style={{ fontSize: 12, color: colors.text }}>Call Us 24/7</div>
                  <a 
                    href="tel:+919150410309" 
                    style={{ fontSize: 16, fontWeight: 600, color: colors.dark, textDecoration: 'none' }}
                    onClick={() => setIsOpen(false)}
                  >
                    +91 91504 10309
                  </a>
                </div>
              </div>
              <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
                <FiMail size={16} color={colors.primary} />
                <div>
                  <div style={{ fontSize: 12, color: colors.text }}>Email</div>
                  <a 
                    href="mailto:micheal0703.mr@gmail.com" 
                    style={{ fontSize: 14, color: colors.dark, textDecoration: 'none' }}
                    onClick={() => setIsOpen(false)}
                  >
                    micheal0703.mr@gmail.com
                  </a>
                </div>
              </div>
            </div>

            {/* Social Links */}
            <div style={{ display: 'flex', justifyContent: 'center', gap: 20, marginTop: 24 }}>
              {[
                { icon: <FaFacebookF size={18} />, url: '#' },
                { icon: <FaTwitter size={18} />, url: '#' },
                { icon: <FaInstagram size={18} />, url: '#' },
                { icon: <FaLinkedinIn size={18} />, url: '#' }
              ].map((social, idx) => (
                <a
                  key={idx}
                  href={social.url}
                  onClick={() => setIsOpen(false)}
                  style={{
                    width: 40,
                    height: 40,
                    borderRadius: '50%',
                    background: colors.gray,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    color: colors.text,
                    transition: 'all 0.2s',
                    cursor: 'pointer'
                  }}
                >
                  {social.icon}
                </a>
              ))}
            </div>

            {/* Close Menu Button */}
            <div style={{ textAlign: 'center', marginTop: 20 }}>
              <button
                onClick={() => setIsOpen(false)}
                style={{
                  padding: '12px 24px',
                  background: 'transparent',
                  border: `1px solid ${colors.gray}`,
                  borderRadius: 8,
                  color: colors.text,
                  fontSize: 14,
                  cursor: 'pointer',
                  width: '100%'
                }}
              >
                Close Menu
              </button>
            </div>
          </nav>
        </div>
      )}

      {/* CSS Animations */}
      <style>{`
        @keyframes fadeIn {
          from {
            opacity: 0;
            transform: translateY(-10px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        @keyframes slideIn {
          from {
            opacity: 0;
            transform: translateY(-10px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
      `}</style>
    </>
  );
};

export default Header;
